












































import {Component, Vue, Ref, Watch} from 'vue-property-decorator';
import DisplayItemChunk from '@/components/display-items/DisplayItemChunk.vue';
import DisplayItemPartition from '@/components/display-items/DisplayItemPartition.vue';
import ScrollList from '@/components/ScrollList.vue';
import io from 'socket.io-client';
import ApiRoutes from '@/logic/ApiRoutes';
import {mapFields} from 'vuex-map-fields';

/**
 * Component for showing display items with the latest partition sticky, and previous content hidden
 */
@Component({
    props: {
        /**
         * Should the newest items be shown at the top
         */
        topFirst: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        DisplayItemChunk,
        DisplayItemPartition,
        ScrollList
    },
    computed: mapFields('settings', [
        'order_top_first'
    ])
})
export default class StickyDisplayItemList extends Vue {
    private partitionExpanded: boolean = false;
    private socket: any;

    get recentDisplayChunks() {
        if (this.$props.topFirst) {

            // Reverse a copy
            return this.$store.getters['performance/recentDisplayChunks'].slice().reverse();
        } else {
            return this.$store.getters['performance/recentDisplayChunks'];
        }
    }

    get recentPartition() {
        return this.$store.getters['performance/recentPartition'];
    }

    private togglePartitionExpanded() {

        // Open history page
        this.$router.push('/history');
    }
}
